import React, { FC, ReactNode } from 'react';
import Loader from '../Loader';
import ButtonStyle from './button.style';

type Props = {
  title?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  loader?: ReactNode;
  loaderColor?: string;
  isMaterial?: boolean;
  isLoading?: boolean;
  variant?: 'textButton' | 'outlined' | 'fab' | 'extendedFab';
  colors?:
    | 'primary'
    | 'secondary'
    | 'warning'
    | 'error'
    | 'primaryWithBg'
    | 'secondaryWithBg'
    | 'warningWithBg'
    | 'errorWithBg';
};

const Button: FC<Props> = ({
  type = 'button',
  title,
  icon,
  disabled,
  iconPosition = 'right',
  onClick,
  loader,
  loaderColor = '#30C56D',
  isMaterial = false,
  isLoading = false,
  className,
  variant = 'textButton',
  colors = 'primary',
  ...props
}) => {
  // Add all classs to an array
  const addAllClasses = ['reusecore__button'];

  // isLoading prop checking
  if (isLoading) {
    addAllClasses.push('is-loading');
  }

  // isMaterial prop checking
  if (isMaterial) {
    addAllClasses.push('is-material');
  }

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  // Checking button loading state
  const buttonIcon =
    isLoading !== false ? (
      <>{loader ? loader : <Loader loaderColor={loaderColor} />}</>
    ) : (
      icon && <span className="btn-icon">{icon}</span>
    );

  return (
    <ButtonStyle
      type={type}
      className={addAllClasses.join(' ')}
      disabled={disabled}
      icon-position={iconPosition}
      onClick={onClick}
      variant={variant}
      colors={colors}
      {...props}
    >
      <>
        {iconPosition === 'left' && buttonIcon}
        {title && <span className="btn-text">{title}</span>}
        {iconPosition === 'right' && buttonIcon}
      </>
    </ButtonStyle>
  );
};

export default Button;
